export const appBarCss = ({ overrideCss, customClassName, } = {}) => {
    const appBar = [];
    const appBarTitle = [];
    const appBarSpace = [];
    const appBarButton = [];
    if (!overrideCss) {
        appBar.push('app-bar');
        appBarTitle.push('app-bar__title');
        appBarSpace.push('app-bar__space');
        appBarButton.push('app-bar__button');
    }
    if (customClassName) {
        appBar.push(`${customClassName}`);
        appBarTitle.push(`${customClassName}__title`);
        appBarSpace.push(`${customClassName}__space`);
        appBarButton.push(`${customClassName}__button`);
    }
    return {
        appBar: appBar.join(' '),
        appBarTitle: appBarTitle.join(' '),
        appBarSpace: appBarSpace.join(' '),
        appBarButton: appBarButton.join(' '),
    };
};
//# sourceMappingURL=appBarCss.js.map